// extracted by mini-css-extract-plugin
export default {"navCard":"NavCard_navCard__cYUM4"};